import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const MetadataUrlInput = ({ helpText = null }) => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("metadataUrl")}
      placeholder={t("metadataUrl")}
      id="metadata_url"
      type="text"
      autoComplete="metadata url"
      required={true}
      helperText={helpText}
    />
  );
};
export default MetadataUrlInput;